export default __webpack_public_path__ + "static/media/GE.e711a737.svg";